import React, {useEffect, useState} from 'react';
import "../../sass/main.scss";
import CmnCard from "../CmnCard";
import $ from "jquery";
import {useHistory} from "react-router-dom";
import Fn from "../../libraries/Fn";
import axios2 from "../../helpers/APIHelper";
import JDatePicker from "../common/JDatePicker";
import TopScroller from "../common/TopScroller";

// 스크립트 없음
const AnalysisSubsStat1 = (props) => {

  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }
  const history = useHistory();

  const [result, setResult] = useState({});
  const [renew, setRenew] = useState(0);

  useEffect(() => {
    $('#s_date1').val(Fn.getCurrentDate());
    $('#s_date2').val(Fn.getCurrentDate());
  }, []);

  useEffect(() => {
    load();
  }, [renew]);

  // 컴포넌트 상단에 로딩 상태를 관리할 state 추가
  const [isLoading, setIsLoading] = useState(false);

  // 로딩 스피너와 배경 딤 처리를 위한 CSS 스타일
  const spinnerStyles = {
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 약간 어둡게
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // 다른 요소들 위에 표시
      flexDirection: 'column'
    },
    spinner: {
      border: '5px solid #f3f3f3',
      borderTop: '5px solid #3498db',
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      animation: 'spin 1s linear infinite',
    },
    loadingText: {
      color: 'white',
      marginTop: '15px',
      fontSize: '16px',
      fontWeight: 'bold'
    }
  };

  // keyframes 애니메이션을 위한 스타일 태그 추가
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  const load = () => {
    $("#overlay").detach();
    // 로딩 시작 시 스피너 표시
    setIsLoading(true);

    axios2
      .post(`/subscription/stat1/ready?srchDtS=${$('#s_date1').val() || ''}&srchDtE=${$('#s_date2').val() || ''}`)
      .then((response) => {
        console.log(response);
        const {code, message, result: _result, pageInfo} = response?.data;
        if (code === 200) {
          setResult(_result);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
        console.log(error);
      })
      .finally(() => {
        // 로딩 종료 시 스피너 숨김 (성공/실패 모두)
        setIsLoading(false);
        $("#overlay").attach();
      });
  }

  return (
    <CmnCard onLogout={props.onLogout}>
      {/* 로딩 스피너 및 딤 처리 */}
      {isLoading && (
        <div style={spinnerStyles.loadingOverlay}>
          <div style={spinnerStyles.spinner}></div>
          <div style={spinnerStyles.loadingText}>데이터를 불러오는 중입니다</div>
        </div>
      )}

      <div className="m-3" style={{clear: 'both'}}>
        <div className="tabs">
          <input id="aa" type="radio" name="tab_item" checked onClick={() => history.push("/analysis/subs/stat1")}/>
          <label className="tab_item" htmlFor="aa">매출</label>

          <input id="bb" type="radio" name="tab_item" onClick={() => history.push("/analysis/subs/stat2")}/>
          <label className="tab_item" htmlFor="bb">지속성</label>

          <input id="cc" type="radio" name="tab_item" onClick={() => history.push("/analysis/subs/stat3")}/>
          <label className="tab_item" htmlFor="cc">쿠폰</label>

          <input id="dd" type="radio" name="tab_item" onClick={() => history.push("/analysis/subs/stat4")}/>
          <label className="tab_item" htmlFor="dd">성별/나이대</label>
        </div>
      </div>

      <div className="overflowX ">
        <div className="d-flex m-3 table_wide_sh2">
          <div className="input-group" style={{width: 'auto'}}>
            <JDatePicker className="form-control" aria-describedby="button-addon2" id="s_date1"/>
            <p className="mx-2">~</p>
            <JDatePicker className="form-control" aria-describedby="button-addon2" id="s_date2"/>
          </div>

          <div className="pr-1">
            <button type="button" className="btn btn-sm btn-point px-3" onClick={() => setRenew(Fn.getRenewTime())}>검색</button>
          </div>
        </div>

        <div className="m-3 pb-2 table_list table_wide_sh2">
          <table className="view-rounded sub_table_border">
            <>
              <colgroup>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
                <col width="*"/>
              </colgroup>
              <tr>
                <th>지점</th>
                {/*<th>전년도</th>*/}
                <th>등록인원</th>
                <th>베이직</th>
                <th>애니패스</th>
                <th>매출(베이직)</th>
                <th>매출(애니패스)</th>
                <th>매출(운동복)</th>
                <th>매출(라커)</th>
                <th>매출(구독합계)</th>
              </tr>
            </>
            {result?.items ? (() => {
              // 각 지점의 행 생성 (명시적 배열 생성)
              const rows = [];

              // 각종 합계 변수 초기화
              const totalRegistered = result.items.reduce((sum, row) => sum + (row?.등록인원 || 0), 0);
              const totalBasic = result.items.reduce((sum, row) => sum + (row?.베이직 || 0), 0);
              const totalAnypass = result.items.reduce((sum, row) => sum + (row?.애니패스 || 0), 0);
              const totalBasicSales = result.items.reduce((sum, row) => sum + (row?.매출_베이직 || 0), 0);
              const totalAnypassSales = result.items.reduce((sum, row) => sum + (row?.매출_애니패스 || 0), 0);
              const totalClothesSales = result.items.reduce((sum, row) => sum + (row?.매출_운동복 || 0), 0);
              const totalLockerSales = result.items.reduce((sum, row) => sum + (row?.매출_라커 || 0), 0);
              const totalPrevYear = result.items.reduce((sum, row) => sum + (row?.전년도 || 0), 0);

              // 각 행의 비율을 저장할 배열
              const registeredRatios = [];
              const basicRatios = [];
              const anypassRatios = [];

              // 각 지점의 행 추가
              result.items.forEach((row, index) => {
                // 베이직+애니패스 합계 계산
                const totalSubscriptions = (row?.베이직 || 0) + (row?.애니패스 || 0);

                // 등록인원 비율 계산
                const registeredRatio = totalRegistered > 0 ? ((row?.등록인원 || 0) / totalRegistered * 100).toFixed(1) : 0;
                registeredRatios.push(parseFloat(registeredRatio));

                // 베이직 비율 계산
                const basicRatio = totalSubscriptions > 0 ? ((row?.베이직 || 0) / totalSubscriptions * 100).toFixed(1) : 0;
                basicRatios.push(parseFloat(basicRatio));

                // 애니패스 비율 계산
                const anypassRatio = totalSubscriptions > 0 ? ((row?.애니패스 || 0) / totalSubscriptions * 100).toFixed(1) : 0;
                anypassRatios.push(parseFloat(anypassRatio));

                rows.push(
                  <tr key={`row-${index}`}>
                    {/*<td>{row?.branch_name}</td>*/}
                    <td>{row?.branch_name}</td>
                    <td>{Fn.numberWithCommas(row?.등록인원)}</td>
                    <td>{Fn.numberWithCommas(row?.베이직)} ({basicRatio}%)</td>
                    <td>{Fn.numberWithCommas(row?.애니패스)} ({anypassRatio}%)</td>
                    <td>{Fn.numberWithCommas(row?.매출_베이직)}</td>
                    <td>{Fn.numberWithCommas(row?.매출_애니패스)}</td>
                    <td>{Fn.numberWithCommas(row?.매출_운동복)}</td>
                    <td>{Fn.numberWithCommas(row?.매출_라커)}</td>
                    <td>{Fn.numberWithCommas((row?.매출_베이직 || 0) + (row?.매출_애니패스 || 0) + (row?.매출_운동복 || 0) + (row?.매출_라커 || 0))}</td>
                  </tr>
                );
              });

              // 총합계 행 추가 - 각 비율의 평균 계산
              const avgRegisteredRatio = registeredRatios.length > 0 ?
                (registeredRatios.reduce((sum, ratio) => sum + ratio, 0) / registeredRatios.length).toFixed(1) : 0;

              const avgBasicRatio = basicRatios.length > 0 ?
                (basicRatios.reduce((sum, ratio) => sum + ratio, 0) / basicRatios.length).toFixed(1) : 0;

              const avgAnypassRatio = anypassRatios.length > 0 ?
                (anypassRatios.reduce((sum, ratio) => sum + ratio, 0) / anypassRatios.length).toFixed(1) : 0;

              // 총 매출 합계 계산
              const totalSales = totalBasicSales + totalAnypassSales + totalClothesSales + totalLockerSales;

              // 총합계 행 추가
              rows.push(
                <tr key="total-row" style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                  {/*<td>총합계</td>*/}
                  <td>총합(평균%)</td>
                  <td>{Fn.numberWithCommas(totalRegistered)}</td>
                  <td>{Fn.numberWithCommas(totalBasic)} ({avgBasicRatio}%)</td>
                  <td>{Fn.numberWithCommas(totalAnypass)} ({avgAnypassRatio}%)</td>
                  <td>{Fn.numberWithCommas(totalBasicSales)}</td>
                  <td>{Fn.numberWithCommas(totalAnypassSales)}</td>
                  <td>{Fn.numberWithCommas(totalClothesSales)}</td>
                  <td>{Fn.numberWithCommas(totalLockerSales)}</td>
                  <td>{Fn.numberWithCommas(totalSales)}</td>
                </tr>
              );

              return rows;
            })() : null}
          </table>
        </div>
      </div>
      <TopScroller/>

    </CmnCard>
  );
};

export default AnalysisSubsStat1;
